import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import CustomerVehiclesTable from "./CustomerVehiclesTable";
import { Navigate, useParams } from "react-router-dom";
const CustomerVehiclesPage = () => {
    const params = useParams();
    const [customer, setCustomer] = useState(null);
    if (!params.customerId || isNaN(Number(params.customerId))) {
        return (_jsx(Navigate, { to: "/customers/list", replace: true }));
    }
    return (_jsx("div", { className: "container-fluid", children: _jsxs("article", { className: "article swz-fixed-table-article", children: [_jsx("h2", { className: "article-title", children: customer ? `${customer.name} Vehicle Tares` : "Loading...." }), _jsx(CustomerVehiclesTable, { customerId: Number(params.customerId), onCustomerChanged: setCustomer })] }) }));
};
export default CustomerVehiclesPage;
